import { Outlet } from "react-router-dom";

const CombustibleWrapper: React.FC = () => {
    return <Outlet />;
};

export default CombustibleWrapper;